import { AppConfig } from '../config';
import { dispatch } from '../store';
import { openSnackbar } from '../store/reducers/snackbar';
import dayjs from 'dayjs';
import { fetchWithAuth } from './fetchWithAuth';

export interface QueryParams {
  [key: string]: string | string[];
}

class ReportApi {
  async handleExportReport(report: string, qp: QueryParams): Promise<void> {
    const params = new URLSearchParams();
    Object.entries(qp).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((val) => {
          params.append(key, val);
        });
      } else if (value !== undefined && value !== null) {
        params.set(key, value);
      }
    });
    try {
      const response = await fetchWithAuth(`${AppConfig.apiRoot}reports/${report}?${params.toString()}`, {
        method: 'GET',
      });
      if (!response.ok) {
        dispatch(
          openSnackbar({
            open: true,
            message: 'Cannot generate report.',
            variant: 'alert',
            alert: {
              color: 'error'
            },
            close: true
          })
        );
        return;
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = `report-${dayjs().format('YYYY-MM-DD')}.xlsx`;
      if (contentDisposition) {
        const matches = contentDisposition.match(/filename="?([^"]+)"?/);
        if (matches && matches.length > 1) {
          filename = matches[1];
        }
      }
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (e) {
      dispatch(
        openSnackbar({
          open: true,
          message: 'Cannot generate report.',
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: true
        })
      );
    }
  }
}

export const reportApi = new ReportApi();
